import { Observable } from "react-use/lib/useObservable"

import StreamAPISocket from "@/api/stable/APISocket"

class OnlineOCBsSource implements Observable<string[]>, Disposable {
  private readonly source = new StreamAPISocket("AdminPanel")

  constructor(readonly companyId: string) { }

  subscribe(callback: (onlineIds: string[]) => void) {
    const fetchConnected = () => {
      this.source.socket.emitWithAck("CONNECTED_OCBS", { companyId: this.companyId }).then(instances => {
        callback(instances.map(instance => instance.appId))
      })
    }

    fetchConnected()

    // Re-fetch after socket reconnection to get current state
    const onReconnect = () => fetchConnected()
    this.source.socket.io.on("reconnect", onReconnect)

    const unsubscribe = this.source.on("CONNECTED_OCB_APPS", next => {
      if (this.companyId !== next.companyId) return

      callback(next.connected.map(appId => appId.slice(appId.indexOf("-") + 1)))
    })
    return {
      unsubscribe: () => {
        unsubscribe()
        this.source.socket.io.off("reconnect", onReconnect)
      }
    }
  }

  [Symbol.dispose]() {
    this.source[Symbol.dispose]()
  }
}

export default OnlineOCBsSource
